import React from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import useSipStates from '../../hooks/useSipStates';
import { workerKeys } from './constants';
import WorkerNameBlock from './components/WorkerNameBlock';
import WorkerDropdown from './components/WorkerDropdown';
import { getWorker, canChangeWorker } from './utils';

const WorkerCell = ({
  request,
  workerKey = workerKeys.master,
  renderContent,
  workerObj,
  considerPaidId = false,
  canCall,
  canChange = true,
  renderIcon,
}) => {
  const userInfo = useSelector((state) => state.authentication.userInfo);

  const { isConnected, isIdle } = useSipStates();

  const worker = getWorker({ request, workerKey, workerObj });

  const allowCall =
    isConnected && isIdle && (worker?.id || worker.phones?.length || canCall);

  const allowChange =
    canChange &&
    canChangeWorker({
      request,
      worker,
      workerObj,
      userInfo,
      considerPaidId,
    });

  if (!allowCall && !allowChange) {
    return (
      <Tooltip
        mouseEnterDelay={0.6}
        mouseLeaveDelay={0}
        title={worker.title}
        placement="topLeft"
      >
        {typeof renderContent === 'function' ? (
          renderContent({ withCursor: false })
        ) : (
          <WorkerNameBlock
            name={worker.fullName}
            speciality={worker.specialityName}
            workerKey={workerKey}
            renderIcon={renderIcon}
          />
        )}
      </Tooltip>
    );
  }

  return (
    <WorkerDropdown
      workerKey={workerKey}
      worker={worker}
      allowCall={allowCall}
      allowChange={allowChange}
      renderContent={renderContent}
      renderIcon={renderIcon}
    />
  );
};

export default WorkerCell;
